import { NgModule } from "@angular/core";
import { CoreModule } from "@modules/core/core.module";
import { BpGeneralBannerComponent } from "@modules/shared/bp-general-banner/bp-general-banner.component";

const components = [BpGeneralBannerComponent];

@NgModule({
	imports: [CoreModule],
	declarations: [components],
	exports: [components]
})
export class BpGeneralBannerModule {}
